import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { styled } from '@mui/material/styles';

export const StyledNavbarContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  height: '56px',
}));

export const StyledLeftSection = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

export const StyledLogo = styled('div')(({ theme }) => ({
  fontSize: '20px',
  width: '120px',
  color: theme.palette.secondary.main,
}));

export const StyledRightSection = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  height: '56px',
  padding: '10px 15px',
}));

export const PopperArrow = styled('span')(() => ({
  position: 'absolute',
  top: '-5px',
  right: '20px',
  width: '10px',
  height: '10px',
  background: 'inherit',
  transform: 'rotate(45deg)',
  zIndex: -1,
  boxShadow: '-1px -1px 1px rgba(0, 0, 0, 0.1)',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.text.secondary,
}));
